/* Shopify hands prices over as `{ amount: "45.0", currencyCode: "EUR" }` — a
   decimal string, so that no arithmetic has happened to it in transit. This is
   the one place that turns one into something a reader recognises. */

const formatters = new Map();

export function formatPrice(money) {
  if (!money) return '';

  // Cached per currency: building an Intl formatter is the expensive part, and
  // a cart redraws this once per line on every quantity change.
  let format = formatters.get(money.currencyCode);
  if (!format) {
    format = new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: money.currencyCode,
    });
    formatters.set(money.currencyCode, format);
  }

  return format.format(Number(money.amount));
}
